import Reveal from "./Reveal";

const reasons = [
  {
    icon: "ri-team-line",
    title: "One Trusted Partner",
    desc: "Bring IT support, cybersecurity, cloud, communications, and technology strategy together under one partner.",
  },
  {
    icon: "ri-bar-chart-box-line",
    title: "Business-Focused",
    desc: "We think beyond technical fixes and focus on how technology affects productivity, security, and growth.",
  },
  {
    icon: "ri-radar-line",
    title: "Proactive Approach",
    desc: "We work to identify potential problems before they disrupt your business.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Long-Term Partnership",
    desc: "Technology changes constantly. We help your business adapt and stay ahead.",
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why-us" className="py-20 md:py-28 bg-background-50 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal className="max-w-2xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            Why Choose Us
          </span>
          <h2 className="mt-3 font-heading font-extrabold text-foreground-950 text-3xl md:text-4xl tracking-tight">
            Why Businesses Choose The Tech Consultants
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {reasons.map((r, i) => (
            <Reveal key={r.title} delay={i * 80}>
              <div className="group h-full rounded-lg border border-background-200 bg-white p-6 transition-all duration-300 hover:border-accent-300 hover:-translate-y-1 cursor-pointer">
                <span className="w-12 h-12 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center group-hover:bg-accent-500 group-hover:text-white transition-colors duration-300">
                  <i className={`${r.icon} text-xl`} />
                </span>
                <h3 className="mt-5 font-heading font-bold text-foreground-950 text-base">
                  {r.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{r.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}